import React from "react";

import { 
    Layout, 
    Typography, 
    Tabs, 
    Tooltip
} from 'antd';
import "./index.css"
import useWindowDimensions from "../../components/useWindowDemision";
import image_search from '../../assets/images/image_search.png';
import Carousel from 'react-multi-carousel';
import DataGetUsmh from "../../services/addproduct";
import 'react-multi-carousel/lib/styles.css';

const { Paragraph } = Typography;
const { TabPane } = Tabs;

const ContentInputCateGory =({
    handleScroll,
    searched,
    dataImg,
    onClickItemProduct,
    localStorageParamUrl,
    setDataImg,
    querys,
    setIndexSlice,
    setActiveKey,
    allProduct
})=>{

    const { Content } = Layout;
    const { width, height } = useWindowDimensions();

    const itemNotSearchs={
        display: 'flex',
        width:width, 
        height:'100%', 
        backgroundColor:'#F1F1F1',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        paddingBottom:40
    }
    const styleTabPan={
        height: height*0.8, 
        width:'100%', 
        overflowY:'scroll',
        flexDirection:'column',
        paddingBottom:50
    }
    const styleContentBody={
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
    }
    const textInItemChild={
        margin:10, 
        alignItems: 'center', 
        display:'flex', 
        width:80, 
    }
    const styleListProduct={
        display:'flex',
        height:135, 
        backgroundColor:'#FFFFFF',
        borderRadius:5,
        margin:5,
        justifyContent:'center',
        alignItems:'center',
        flexDirection: 'column',
        padding: 20, 
        marginBottom:20, 
        marginTop:0
    }
    const responsive = {

        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 3
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 3
        },
        tablet: {
            breakpoint: { max: 1024, min: 375 },
            items: 3
        },
        mobile: {
            breakpoint: { max: 375, min: 0 },
            items: 3
        },
    };

    const itemNotSearch=()=>{
        return(
            <div style={itemNotSearchs}>
                <div style={{ width:145, height:145}}>
                    <img src={image_search} width="100%" height="100%" alt="imageSearch"/>
                </div>
                <Paragraph 
                    className="text-not-search" 
                    ellipsis={true}> 一致する検索結果がありません。</Paragraph>
            </div>
        );
    };

    const dataTabs =(item_all, index)=>{

        const listTabPane =(itemChild, index2 )=>{

            const dataSearchPrd = itemChild.product_list_search || []
    
            const itemChildProduct =(itemPrd, index3)=>{
                return(
                    <div 
                        key={index3} 
                        style={{...styleListProduct,  border:itemPrd.isChoose?'2px solid #FF892A' : ''}}
                        onClick={()=>onClickItemProduct(itemPrd, index3)}
                    >
                        <div style={{width:80, height:80, padding:5}}>
                            <img
                                alt={index3.toString()}
                                style={{marginTop:10, height: '100%', width: '100%'}}
                                src={
                                    dataImg.filter((item_url)=> item_url.item_code === itemPrd.jan_code)[0]? 
                                    dataImg.filter((item_url)=> item_url.item_code === itemPrd.jan_code)[0]?.image_url : 
                                    'https://usmh-image.com/stage-thumbnail/item/100/79/4904210460479.jpg'
                                }
                            />
                        </div>
    
                        <div style={textInItemChild}>
                            <Paragraph 
                                className="text_item_category" 
                                ellipsis={true}>
                                {itemPrd.food_name?itemPrd.food_name:''}
                            </Paragraph>
                            
                        </div>
    
                        <div 
                            className="packing-spec-search" 
                            style={{ backgroundColor:itemPrd.isChoose? '#09D3B7' :'#CCCCCC', position:'fixed', bottom:10}}> 
                            <Paragraph 
                                className="text-packing-search" 
                                ellipsis={true}>
                                { Math.round((itemPrd.packing_spec*100) * 100) / 100  + "グラム"}
                            </Paragraph>
                        </div>
                    </div>
                );
            };
    
            const itemChildCategory =(dataChild)=>{
                return(
                    <div>
                        <Tooltip 
                            title={itemChild.category_name? itemChild.category_name : ''}
                            placement="topLeft" 
                        >
                            <div style={{ width:200}}>
                                <Paragraph 
                                    style={{marginTop:10}}
                                    className="text-category-list-hr" 
                                    ellipsis={true}> 
                                    {itemChild.category_name? itemChild.category_name : ''}
                                </Paragraph>
                            </div>
                        </Tooltip>
                        <Carousel 
                            afterChange = {( previousSlide ,  { currentSlide , onMove } )  =>  { 
                                if(currentSlide > previousSlide ){
                                    const dataParam = dataChild
                                    .slice(5*currentSlide, (5*currentSlide)+5)
                                    .map((value)=>{
                                        return{
                                            item_code:value.jan_code
                                        }
                                    });
                                    if(dataParam.length <1) return;
    
                                    return(
                                        DataGetUsmh.getImgProduct(
                                            {...localStorageParamUrl, list_jancode: dataParam},
                                            (res) => {
                            
                                                if(res.result && res.result === 'success'){
                                                    if(res?.data?.data?.length > 0){
                                                        setDataImg((value) => value.concat(...res.data?.data.filter(item_img => item_img.image_url) ));
                                                    }
                                                }
                                                if(res.result && res.result === 'failure'){
                                                    // setDataImg([]);
                                                }
                                            }
                                        )
                                    )
                                }}
                            } 
                            responsive={responsive}
                        >
                            {dataChild.map((itemPrd, index3) => itemChildProduct(itemPrd, index3))}
                        </Carousel>
                    </div>
                )
            }
    
            return(
                <div key={index2.toString()} style={{ margin:5}} >
                    {(itemChild?.product_list?.length > 0 && !querys)?
                        itemChildCategory(itemChild?.product_list) 
                        : (dataSearchPrd.length > 0 && querys)? itemChildCategory(dataSearchPrd):null
                    }
                </div>
            );
        };

        return(
            <TabPane 
                tab={
                    <Paragraph 
                        className="tab-text-title" 
                        ellipsis={true}> 
                        {item_all.category_name? item_all.category_name : ''}
                    </Paragraph>
                }
                key={index.toString()}>
                <div 
                    onScroll={handleScroll} 
                    style={styleTabPan}
                >
                    { searched ? item_all.category_child?.map((itemChild, index2) => listTabPane(itemChild, index2))
                        :!searched? itemNotSearch():null
                    } 
                </div>
            </TabPane>
        )
    }

    return(
        <Content style={styleContentBody}>
            <Tabs 
                defaultActiveKey="0" 
                tabPosition={'top'} 
                style={{ height: '100%', width:'100%',}}
                onChange={(value)=>{
                    setIndexSlice(6);
                    setActiveKey(value);
                    
                }}>
                { !querys ? allProduct.map((item_all, index) => dataTabs(item_all, index))
                    :allProduct.filter(item_tab => item_tab.isShowTabs).map((item_all, index) => dataTabs(item_all, index))
                }
            </Tabs> 
        </Content>
    )
};

export default ContentInputCateGory